import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy Images tab URL — the tab and the Image check stage were removed from the UI
 * (2026-10-16). Redirects old links/bookmarks to Summary (default stage) so they never 404.
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/images',
)({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({
      to: '/catalog-enrichment/runs/$runId',
      params: { runId: params.runId },
      replace: true,
    });
  },
});
